import React from 'react'
import Header from '../../sharedcomponents/header/Index'
import SubNav2 from '../../sharedcomponents/header/SubNav2'
import TxtIntro1 from '../../sharedcomponents/TextIntro/TxtIntro1'
import Cards from '../../components/services/Cards.js'
import ParallaxOtherPages from '../../sharedcomponents/parallaxOtherPages/parallaxOtherPages.js';
import {imgHome4} from '../../sharedcomponents/ImageScope';
import Footer from '../../sharedcomponents/footer/Index.js';

import './index.css'
export default function Localization(){
  return(
    <>
      <div style={{maxWidth:'1920px'}}>
        <Header localizationActive={"active"}/>
        <SubNav2/>
        <ParallaxOtherPages
          parallaxOtherPages_bg={imgHome4}
          // parallaxOtherPages_title="Nossos Localição."
          // parallaxOtherPages_desc=""
          // parallaxOtherPages_txt="Temos os melhores serviços que uma gráfica pode lhe oferecer."
        />
        <br/>
        <br/>
        <br/>
        <TxtIntro1
           TxtIntro_title={"Conheça mais sobre os serviços da HS Design."}
           TxtIntro_description={"Saiba mais onde estamos localizados por via do mapa somos."}
        />
         <div className="mapa">
          <div className="container">

            <iframe className="iframe-mapa"
              src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3372.5820162067353!2d13.228597214338597!3d-8.844252393006931!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x1a51f39830fc866d%3A0x882b5c13451898e2!2sHS+Design!5e1!3m2!1spt-PT!2sao!4v1555429451842!5m2!1spt-PT!2sao"
              width="100%" height="450" frameborder="0" style={{border:'0'}} allowfullscreen></iframe>

          </div>
        </div>
        <Footer/>
      </div>
    </>
  );
}